export * from '@primeuix/themes/nora/galleria';
export { default } from '@primeuix/themes/nora/galleria';
